import { usePathname } from 'expo-router';
import { useFormContext } from 'react-hook-form';
import { StyleSheet } from 'react-native-unistyles';
import Box from '@/components/Unistyles/Box';
import Icon from '@/components/Unistyles/Icon';
import Pressable from '@/components/Unistyles/Pressable';
import Text from '@/components/Unistyles/Text';
import type { WelcomeFormValues } from '@/layouts/Welcome/form';
import signOut from '@/utils/signOut';
import WelcomeSkipSetupButton from './WelcomeSkipSetupButton';

export default function WelcomeHeaderActions() {
  const pathname = usePathname();
  const { formState } = useFormContext<WelcomeFormValues>();
  const showSignOut = pathname.endsWith('/welcome/profile');

  return (
    <Box direction="horizontal" alignItems="center" space="sm">
      {showSignOut ? (
        <Pressable
          accessibilityLabel="Sign out"
          accessibilityRole="button"
          disabled={formState.isSubmitting}
          hitSlop={20}
          onPress={() => {
            void signOut();
          }}
          styleOverride={({ pressed }) => [
            styles.signOutButton,
            pressed ? styles.pressed : null,
          ]}
          testID="WelcomeSignOut"
        >
          <Icon
            name="log-out-outline"
            size="xl"
            variant="typographySecondary"
          />
          <Text
            size="lg"
            style={styles.signOutLabel}
            variant="typographySecondary"
          >
            Sign out
          </Text>
        </Pressable>
      ) : null}
      <WelcomeSkipSetupButton />
    </Box>
  );
}

const styles = StyleSheet.create((theme) => ({
  pressed: {
    opacity: 0.8,
  },
  signOutButton: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: theme.space('xs'),
    justifyContent: 'center',
    paddingHorizontal: theme.space('sm'),
    paddingVertical: theme.space('xs'),
    _web: {
      paddingHorizontal: theme.space('lg'),
      _hover: {
        opacity: 0.8,
      },
    },
  },
  signOutLabel: {
    fontWeight: theme.fontWeight.semibold,
  },
}));
